import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import IconButton from "../../../../components/IconButton";
import { IconCheck } from "../../../../icons";
import { TitleMobile } from "../components/TitleMobile";

export default function Registered() {
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      history.push("/timesheet");
    }, 3000);
  }, []);

  return (
    <>
      <div className="h-40"></div>
      <div className="w-screen h-4/6 flex-col -ml-8 p-8  flex items-center justify-evenly">
        <div className="w-4/5 flex items-center justify-center rounded-full bg-primary font-semibold font-familyPoppins text-6xl box-registered">
          Registrado! <IconButton icon={IconCheck} className="font-bold bg-green-500 rounded-full ml-4" />
        </div>
      </div>
    </>
  );
}
